import { Box, useTheme } from '@mui/material';
import { ContentCard } from '../../components/ContentCard/ContentCard';
import { Copy } from '../../copy/Copy';
import { dynamicTextColor } from '../../helpers/dynamicTextColor';
import { Accordion } from '../../components/Accordion/Accordion';
import { HELP_ACCORDIONS } from '../../constants/helpAccordions';
import { Button } from '../../components/Button/Button';
import { NHS_LINK } from '../../constants/links';
import { buttonSx } from '../../styles/Global.style';
import { accordionContainerSx } from './Help.style';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';

export const Help = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <ContentCard
        title={Copy.generate('Help.mental.title')}
        heading={Copy.inject('Help.mental.heading', {
          support: dynamicTextColor(
            'urgently need support',
            theme.palette.quaternary.main,
          ),
        })}
        isColumn
        isTop
      >
        <Box>
          <Button
            text={Copy.generate('Buttons.support')}
            onClick={() => window.open(NHS_LINK)}
            sx={buttonSx(theme)}
          />
        </Box>
      </ContentCard>

      <ContentCard
        title={Copy.generate('Help.questions.title')}
        heading={Copy.inject('Help.questions.heading', {
          m4mh: dynamicTextColor('M4MH.', theme.palette.quaternary.main),
        })}
        isColumn
        isSecondaryCard
      >
        <Box sx={accordionContainerSx}>
          {HELP_ACCORDIONS.map((a, i) => (
            <Accordion key={i} heading={a.heading} content={a.content} />
          ))}
        </Box>
      </ContentCard>

      <ContentCard
        title={Copy.generate('Help.feedback.title')}
        heading={Copy.inject('Help.feedback.heading', {
          love: dynamicTextColor('love to hear', theme.palette.quaternary.main),
        })}
        isColumn
      >
        <Box>
          <Button
            text={Copy.generate('Buttons.feedback')}
            onClick={() => navigate(APP_PATHS.feedback)}
            sx={buttonSx(theme)}
          />
        </Box>
      </ContentCard>
    </>
  );
};
